import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginRegister.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import logo from "./images/logo123.png";

const Register = () => {
  const [regformData, setRegFormData] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
  });

  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const ReghandleChange = (e) => {
    setRegFormData({ ...regformData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!regformData.name.trim()) {
      newErrors.name = "Ad boş ola bilməz.";
    }
    if (!regformData.phone.trim()) {
      newErrors.phone = "Telefon nömrəsi boş ola bilməz.";
    } else if (!/^\+[1-9]\d{1,14}$/.test(regformData.phone)) {
      newErrors.phone = "Telefon nömrəsi beynəlxalq formatda olmalıdır (məsələn, +994507330265).";
    }
    if (!regformData.email.trim()) {
      newErrors.email = "Email boş ola bilməz.";
    } else if (!/\S+@\S+\.\S+/.test(regformData.email)) {
      newErrors.email = "Email düzgün formatda deyil.";
    }
    if (!regformData.password.trim()) {
      newErrors.password = "Şifrə boş ola bilməz.";
    } else if (regformData.password.length < 8) {
      newErrors.password = "Şifrə ən azı 8 simvoldan ibarət olmalıdır.";
    } else if (regformData.password.length > 20) {
      newErrors.password = "Şifrə ən çox 20 simvoldan ibarət olmalıdır.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const ReghandleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const response = await fetch(
        "https://dev-api.sahibindenal.az/auth/api/v1/register",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(regformData),
        }
      );

      const responseText = await response.text();

    let data;
    try {
    
      data = responseText ? JSON.parse(responseText) : {};
    } catch (jsonError) {
     
      data = { message: responseText };
    }

    if (response.ok) {
      setMessage("Qeydiyyat uğurlu!");
      setRegFormData({ name: "", phone: "", email: "", password: "" });
      setTimeout(() => navigate("/login"), 2000);
    } else {
      const errorText = data.message ? data.message.toLowerCase() : (typeof data === 'string' ? data.toLowerCase() : JSON.stringify(data).toLowerCase());
      if (
        errorText.includes("duplicate") ||
        errorText.includes("already exists") ||
        errorText.includes("unique constraint")
      ) {
        setMessage("Bu email artıq qeydiyyatdan keçib.");
      } else {
        setMessage(data.message || "Xəta baş verdi: " + (responseText || "Naməlum səbəb"));
      }
    }
  } catch (error) {
    console.error("Xəta:", error);
    setMessage("Server ilə əlaqə yaratmaq mümkün olmadı.");
  }
};

  return (
    <div className="container">
      <div className="form-container">
        <div className="form">
          <img src={logo} alt="Logo" style={{ width: "200px", marginBottom: "20px" }} /> {/* Loqonu əlavə edirik */}
          <h2 style={{ color: "#007bff" }}>Qeydiyyat Formu</h2>
          {message && (
            <p style={{ color: message.includes("uğurlu") ? "green" : "red", fontWeight: "bold" }}>
              {message}
            </p>
          )}
          <input
            type="text"
            name="name"
            placeholder="Ad"
            value={regformData.name}
            onChange={ReghandleChange}
            required
          />
          {errors.name && <p style={{ color: "red", fontSize: "0.9rem" }}>{errors.name}</p>}
          <input
            type="text"
            name="phone"
            placeholder="Telefon nömrəsi"
            value={regformData.phone}
            onChange={ReghandleChange}
            required
          />
          {errors.phone && <p style={{ color: "red", fontSize: "0.9rem" }}>{errors.phone}</p>}
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={regformData.email}
            onChange={ReghandleChange}
            required
          />
          {errors.email && <p style={{ color: "red", fontSize: "0.9rem" }}>{errors.email}</p>}
          <div style={{ position: "relative", width: "100%", marginBottom: "10px" }}>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Şifrə"
              value={regformData.password}
              onChange={ReghandleChange}
              required
              style={{ width: "100%", paddingRight: "30px", boxSizing: "border-box" }}
            />
            <span
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
              onClick={() => setShowPassword(!showPassword)}
            >
              <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
            </span>
          </div>
          {errors.password && <p style={{ color: "red", fontSize: "0.9rem" }}>{errors.password}</p>}
          <button onClick={ReghandleSubmit}>Təsdiq et</button>
          <p>
            Artıq hesabınız var?{" "}
            <span style={{ color: "#007bff", cursor: "pointer" }} onClick={() => navigate("/auth/api/v1/login")}> {}
              Daxil olun
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;